import React from 'react';
import { services, content } from '../content/services.content';

const ServicesSection = () => (
  <section id="services" className="bg-primary text-white py-16">
    <div className="container mx-auto px-6">
      <h2 className="text-4xl font-bold text-center mb-8">{content.name}</h2>

      <p className="text-center leading-relaxed pb-12">
        {content.description}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, idx) => (
          <div
            key={idx}
            className="bg-secondary text-primary p-6 rounded shadow hover:shadow-lg transition"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold">{service.title}</h3>
            </div>

            <ul className="list-disc space-y-1 ml-10">
              {service.details.map((item, i) => (
                <li key={i} className="leading-relaxed text-text">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
